import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { retry, tap } from 'rxjs/operators';

import {
  InstanceDto,
  UpdateInstanceDto,
} from '@plugins/vibecoding-lib/instance';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private readonly http = inject(HttpClient);
  private readonly instanceSubject = new ReplaySubject<InstanceDto>(1);
  public readonly instance$ = this.instanceSubject.asObservable();
  public instance!: InstanceDto;

  private setInstance(instance: InstanceDto): InstanceDto {
    this.instance = instance;
    this.instanceSubject.next(instance);
    return instance;
  }

  fetchInstance(): Observable<InstanceDto> {
    return this.http.get<InstanceDto>('/api/instance').pipe(
      retry({ delay: 7000 }),
      tap((instance) => this.setInstance(instance)),
    );
  }

  updateInstance(instance: UpdateInstanceDto): Observable<InstanceDto> {
    return this.http
      .patch<InstanceDto>('/api/instance', { instance })
      .pipe(tap((updated) => this.setInstance(updated)));
  }

  restoreVersion(versionId: string): Observable<InstanceDto> {
    return this.http
      .patch<InstanceDto>(`/api/instance/restore/${versionId}`, {})
      .pipe(tap((updated) => this.setInstance(updated)));
  }
}
